/** Iniciais (primeira + última palavra) do nome; `null` quando o nome está vazio. */
export function getInitials(name?: string | null): string | null {
  const parts = name?.trim().split(/\s+/).filter(Boolean) ?? [];
  if (parts.length === 0) return null;

  const first = parts[0]!.charAt(0);
  const last = parts.length > 1 ? parts[parts.length - 1]!.charAt(0) : "";
  return `${first}${last}`.toUpperCase();
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** `true` quando o texto parece um e-mail (o literal `system` e textos livres não são). */
export function isEmail(value?: string | null): value is string {
  return EMAIL_PATTERN.test(value?.trim() ?? "");
}
